export const copyToClipboard = async (value: string | ClipboardItem) => {
  try {
    if (typeof value === "string") {
      await navigator.clipboard.writeText(value);
    } else if (value instanceof ClipboardItem) {
      await navigator.clipboard.write([value]);
    }
  } catch (error) {
    console.error("Failed to copy: ", error);
  }
};
